<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-form :inline="true" label-width="100px" class="formInline" size="mini">
          <el-form-item>
            <el-button class="search-btn" @click="getData" style="float: left;">查询</el-button>
            <el-button v-if="editAuth" class="search-btn" @click="addVirtualProjectDialog"
                       style="float: left;margin-left: 0px!important;">新增
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table :data="tableData" size="small" v-loading="listLoading" element-loading-text="拼命加载中" border
                  header-row-class-name="table-header" style="width: 100%;">
          <el-table-column type="index" label="#" align="center" width="50"></el-table-column>
          <el-table-column prop="projectCode" label="项目编号" align="center" width="200"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center" width="200"></el-table-column>
          <el-table-column prop="serviceSupplier" label="签约平台" align="center" width="200"></el-table-column>
          <el-table-column prop="status" label="项目状态" align="center" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0">已结束</div>
              <div v-if="scope.row.status == 1">进行中</div>
            </template>
          </el-table-column>
          <el-table-column prop="companyName" label="所属公司" align="center" width="200"></el-table-column>
          <el-table-column prop="batchNo" label="任务批次" align="center" width="100"></el-table-column>
          <el-table-column prop="supplierCode" label="供应商编号" align="center" width="200"></el-table-column>
          <el-table-column prop="supplierName" label="供应商名称" align="center" width="200"></el-table-column>
          <el-table-column prop="serviceId" label="服务商编号" align="center" width="200"></el-table-column>
          <el-table-column prop="serviceNm" label="服务商名称" align="center" width="200"></el-table-column>
          <el-table-column prop="beginDate" label="供应商开始日期" align="center" width="200"></el-table-column>
          <el-table-column prop="endDate" label="供应商结束日期" align="center" width="200"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" align="center" width="200"></el-table-column>
          <el-table-column prop="updatedBy" label="操作者" align="center" width="100"></el-table-column>
          <el-table-column v-if="editAuth" label="操作" align="center" width="200" fixed="right">
            <template slot-scope="scope">
              <span style="color: #1652ff; cursor: pointer;" @click="getVirtualProjectInfo(scope.row.id)">修改</span>
              <span style="color: #1652ff; cursor: pointer;" @click="supplierListDialog(scope.row.projectCode)">供应商维护</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="formConditionData.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="formConditionData.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>
    <!--编辑虚拟项目信息弹出框-->
    <el-dialog title="编辑项目信息" :visible.sync="showAddDialog" width="40%" center>
      <hr style="margin-bottom: 9px">
      <div class="add-select" style="text-align: center; margin-top: 50px;">
        <el-form ref="addData" :model="addData" label-width="200px" size="small"
                 label-position="left">
          <el-form-item label="项目编号1" :required="true">
            <el-input type="text" v-model="addData.projectCode" size="small" style="width:200px" :disabled="this.addData.id != null"
                      @keyup.native="inputLimit2"
                      placeholder="请输入项目编号" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" :required="true">
            <el-input type="text" v-model="addData.projectName" size="small" style="width:200px"
                      @keyup.native="inputLimit3"
                      placeholder="请输入项目名称" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="签约平台" :required="true">
            <el-select v-model="addData.serviceSupplier" filterable placeholder="请选择签约平台...">
               <el-option :label="item" :value="item" v-for="item in serviceSuppliers"
                           :key="item"></el-option>
              <!-- <el-option label="薪太软" value="薪太软"></el-option>
              <el-option label="众简" value="众简"></el-option>
              <el-option label="博尔捷" value="博尔捷"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="项目状态" :required="true">
            <el-select v-model="addData.status" filterable placeholder="请选择项目状态...">
              <el-option label="进行中" :value="1"></el-option>
              <el-option label="已结束" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属公司" :required="true">
            <el-select v-model="addData.company" value-key="code" filterable placeholder="请选择所属公司..." clearable>
              <el-option v-for="item in companiesAll" :label="item.name" :value="item" :key="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务批次" :required="true">
            <el-input type="text" v-model="addData.batchNo" size="small" style="width:200px" @keyup.native="inputLimit4"
                      placeholder="请输入任务批次" maxlength="10"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="addVirtualProject">确定</el-button>
          <el-button class="search-btn" @click="showAddDialog=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!--供应商维护列表弹出框-->
    <el-dialog class="dialog" title="供应商维护" :visible.sync="showSupplierDialog" width="70%" center
               v-loading="supplierListLoading">
      <el-form :inline="true" label-width="150px" class="formInline" size="mini">
        <el-form-item style="float:left;">
          <el-button class="search-btn" @click="editSupplierDialog()">新增</el-button>
        </el-form-item>
      </el-form>
      <div class="tableBody">
        <el-table class="table-expand" style="width: 100%;" size="small" border :data="supplierTableData">
          <el-table-column width="100" type="index" label="编号" align="center"/>
          <el-table-column width="150" prop="supplierCode" label="供应商编号" align="center"/>
          <el-table-column width="150" prop="supplierName" label="供应商名称" align="center"/>
          <el-table-column width="150" prop="supplierBank" label="供应商开户行" align="center"/>
          <el-table-column width="150" prop="supplierBankAccount" label="供应商银行账号" align="center"/>
          <el-table-column width="150" prop="serviceId" label="服务商编号" align="center"/>
          <el-table-column width="150" prop="serviceNm" label="服务商名称" align="center"/>
          <el-table-column width="150" prop="serviceOpenBank" label="服务商开户行" align="center"/>
          <el-table-column width="150" prop="serviceOpenBankCardNo" label="服务商银行账号" align="center"/>
          <el-table-column width="150" prop="beginDate" label="供应商开始日期" align="center"/>
          <el-table-column width="150" prop="endDate" label="供应商结束日期" align="center"/>
          <el-table-column width="150" prop="updatedBy" label="操作者" align="center"/>
          <el-table-column width="150" prop="updateTime" label="操作时间" align="center"/>
          <el-table-column v-if="editAuth" label="操作" align="center" width="200">
            <template slot-scope="scope">
              <span style="color: #1652ff; cursor: pointer;" @click="editSupplierDialog(scope.row.id)">修改</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSupplierSizeChange"
                       @current-change="handleSupplierCurrentChange"
                       :current-page="supplierConditionData.pageNo"
                       :page-sizes="[10, 20, 50, 100]" :page-size="supplierConditionData.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="supplierTotal">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 供应商维护弹出框 -->
    <el-dialog title="供应商维护" :visible.sync="showSupplierEditDialog" width="40%" center>
      <hr style="margin-bottom: 9px">
      <div class="add-select" style="text-align: center; margin-top: 50px;">
        <!-- <pre>{{ editSupplierData }}</pre> -->
        <el-form ref="editSupplierData" :model="editSupplierData" label-width="200px" size="small"
                 label-position="left">
          <el-form-item label="选择供应商" :required="true">
            <el-select v-model="editSupplierData.supplier" value-key="code" filterable placeholder="请选择供应商..." clearable
                       :disabled="editSupplierFlag"
                       @change="searchOpenBanks(1)"
                       @clear="editSupplierData.supplierBank = null,editSupplierData.supplierBankAccount = null">
              <el-option v-for="item in suppliersAll" :label="item.name" :value="item" :key="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商开户行" :required="true">
            <el-select v-model="editSupplierData.supplierBank" value-key="code" filterable placeholder="请选择供应商开户行..."
                       :disabled="editSupplierFlag"
                       clearable
                       @change="searchOpenBankNos(1)"
                       @clear="editSupplierData.supplierBankAccount = null">
              <el-option v-for="item in openBanks" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商银行账号" :required="true">
            <el-select v-model="editSupplierData.supplierBankAccount" value-key="code" filterable
                       :disabled="editSupplierFlag"
                       placeholder="请选择供应商银行账号..." clearable>
              <el-option v-for="item in openBankNos" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择服务商" >
            <el-select v-model="editSupplierData.service" value-key="code" filterable placeholder="请选择服务商..." clearable
                       :disabled="editSupplierFlag"
                       @change="searchOpenBanks(2)"
                       @clear="editSupplierData.serviceOpenBank = null,editSupplierData.serviceOpenBankCardNo = null">
              <el-option v-for="item in servicesAll" :label="item.name" :value="item" :key="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务商开户行" >
            <el-select v-model="editSupplierData.serviceOpenBank" value-key="code" filterable placeholder="请选择服务商开户行..."
                       :disabled="editSupplierFlag"
                       clearable
                       @change="searchOpenBankNos(2)"
                       @clear="editSupplierData.serviceOpenBankCardNo = null">
              <el-option v-for="item in serviceOpenBanks" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务商银行账号" >
            <el-select v-model="editSupplierData.serviceOpenBankCardNo" value-key="code" filterable
                       :disabled="editSupplierFlag"
                       placeholder="请选择服务商银行账号..." clearable>
              <el-option v-for="item in serviceOpenBankNos" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商开始日期" :required="true">
            <el-date-picker value-format="yyyy-MM-dd" v-model="editSupplierData.beginDate" type="date"></el-date-picker>
          </el-form-item>
          <el-form-item label="供应商结束日期" :required="true">
            <el-date-picker value-format="yyyy-MM-dd" v-model="editSupplierData.endDate" type="date"></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="editSupplier">确定</el-button>
          <el-button class="search-btn" @click="showSupplierEditDialog=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'

  export default {
    data() {
      return {
        // 是否有编辑权限
        editAuth: false,
        // 公司下拉列表
        companiesAll: [],
        // 落地方下拉列表
        suppliersAll: [],
        // 落地方开户行下拉列表
        openBanks: [],
        // 落地方开户行账号下拉列表
        openBankNos: [],
        // 落地方开户行下拉列表
        serviceOpenBanks: [],
        // 落地方开户行账号下拉列表
        serviceOpenBankNos: [],
         // 服务商下拉列表
         servicesAll: [],

        // 虚拟项目页面加载
        listLoading: false,
        // 虚拟项目列表查询条件
        formConditionData: {
          pageNo: 1,
          pageSize: 10
        },
        // 虚拟项目编辑信息
        addData: {
          id: null,
          projectCode: null,
          projectName: null,
          serviceSupplier: null,
          status: null,
          company: null,
          batchNo: null
        },
        // 虚拟项目列表数据
        tableData: [],
        // 虚拟项目总数
        total: null,
        // 虚拟项目编辑弹出框
        showAddDialog: false,

        // 供应商列表加载
        supplierListLoading: false,
        // 供应商列表查询条件
        supplierConditionData: {
          projectCode: null,
          pageNo: 1,
          pageSize: 10
        },
        // 供应商列表数据
        supplierTableData: [],
        // 供应商总数
        supplierTotal: null,
        // 供应商列表弹出框
        showSupplierDialog: false,
        // 供应商编辑弹出框
        showSupplierEditDialog: false,

        // 供应商编辑弹出来
        showSupplierEditDialog: false,
        // 供应商所属项目编号
        supplierProjectCode: null,
        // 供应商编辑数据
        editSupplierData: {
          id: null,
          projectCode: null,
          supplier: null,
          supplierBank: null,
          supplierBankAccount: null,
          beginDate: null,
          endDate: null,
          service: null,
          serviceOpenBank: null,
          serviceOpenBankCardNo: null,
        },
        // 是否为供应商编辑
        editSupplierFlag: false,
        serviceSuppliers: []
      }
    },
    mounted() {
      this.getEditVirtualProjectAuth();
      this.searchCompaniesAll();
      this.searchSuppliersAll();
      this.searchServicesAll();
      this.getData();
      this.getServiceSuppliers();
    },
    methods: {
      /**
       * 判断是否有编辑权限
       */
      getEditVirtualProjectAuth() {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/edit-auth'
        }).then(res => {
          this.editAuth = res.data.data
        }).catch(err => {
        })
      },
      /**
       * 查询虚拟项目维护列表数据
       */
      getData() {
        this.listLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/list',
          params: this.formConditionData
        }).then(res => {
          this.tableData = res.data.data.items;
          this.total = res.data.data.totalItemsCount;
          this.listLoading = false;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      /**
       * 查询公司下拉列表
       */
      searchCompaniesAll() {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/companies'
        }).then(res => {
          this.companiesAll = res.data.data
        }).catch(err => {
        })
      },
      /**
       * 查询落地方下拉列表
       */
      searchSuppliersAll() {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/suppliers-all'
        }).then(res => {
          this.suppliersAll = res.data.data
        }).catch(err => {
        })
      },
       /**
       * 查询服务商下拉列表
       */
       searchServicesAll() {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/services-all'
        }).then(res => {
          this.servicesAll = res.data.data
        }).catch(err => {
        })
      },
      /**
       * 查询落地方&服务商开户行下拉列表
       * type 1:落地方 2:服务商
       */
      searchOpenBanks(type) {
        if (type == 1) {
          this.editSupplierData.supplierBank = null;
          this.editSupplierData.supplierBankAccount = null
          if (!this.editSupplierData.supplier.code) {
           return;
          }
          this.doSearchOpenBanks(this.editSupplierData.supplier.code, type);
        }else if (type == 2) {
          this.editSupplierData.serviceOpenBank = null;
          this.editSupplierData.serviceOpenBankCardNo = null
          if (!this.editSupplierData.service.code) {
            return;
          }
          this.doSearchOpenBanks(this.editSupplierData.service.code, type);

        }
    
      },
      doSearchOpenBanks(supplierId,type) {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/open-banks',
          params: {
            // supplierId: this.editSupplierData.supplier.code
            supplierId: supplierId
          }
        }).then(res => {
          if (type == 1) {
          this.openBanks = res.data.data;
          }else if (type == 2) {
            this.serviceOpenBanks = res.data.data;
          }
        }).catch(err => {
        })
      },
      /**
       * 查询落地方&服务商开户行账户下拉列表
       * type 1:落地方 2:服务商
       */
      searchOpenBankNos(type) {
        if (type == 1) {
          this.editSupplierData.supplierBankAccount = null;
        if (!this.editSupplierData.supplier.code || !this.editSupplierData.supplierBank) {
          return;
        }
        this.doSearchOpenBankNos(this.editSupplierData.supplier.code,this.editSupplierData.supplierBank, type);
        }else if (type == 2) {
          this.editSupplierData.serviceOpenBankCardNo = null;
          if (!this.editSupplierData.service.code || !this.editSupplierData.serviceOpenBank) {
            return;  }

          this.doSearchOpenBankNos(this.editSupplierData.service.code,this.editSupplierData.serviceOpenBank, type);
        }
        
      },
      doSearchOpenBankNos(supplierId, openBank,type) {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/open-bank-nos',
          params: {
            // supplierId: this.editSupplierData.supplier.code,
            // openBank: this.editSupplierData.supplierBank
            supplierId: supplierId,
            openBank: openBank
          }
        }).then(res => {
          if (type == 1) {
          this.openBankNos = res.data.data;
          }else if (type == 2) {
            this.serviceOpenBankNos = res.data.data;
          }
        }).catch(err => {
        })
      },
      /**
       *虚拟项目列表分页信息变化
       * @param val
       */
      handleSizeChange(val) {
        this.formConditionData.pageSize = val;
        this.getData();
      },
      /**
       * 虚拟项目列表分页信息变化
       * @param val
       */
      handleCurrentChange(val) {
        this.formConditionData.pageNo = val;
        this.getData();
      },
      /**
       * 打开虚拟项目维护弹出框
       */
      addVirtualProjectDialog() {
        this.clearAddData();
        this.showAddDialog = true;
      },
      /**
       * 清除页面缓存的编辑虚拟项目数据
       */
      clearAddData() {
        this.addData = {
          id: null,
          projectCode: null,
          projectName: null,
          status: null,
          company: null,
          batchNo: null
        };
      },
      /**
       * 修改虚拟项目数据
       */
      addVirtualProject() {
        if (!this.addData.projectCode) {
          alert("未填写项目编号");
          return;
        }
        if (!this.addData.projectName) {
          alert("未填写项目名称");
          return;
        }
        if(!this.addData.serviceSupplier) {
          alert("未选择签约平台");
          return;
        }
        if (!this.addData.company) {
          alert("未选择所属公司");
          return;
        }
        if (!this.addData.batchNo) {
          alert("未填写任务批次");
          return;
        }
        var submitData = {
          id: this.addData.id,
          projectCode: this.addData.projectCode,
          projectName: this.addData.projectName,
          serviceSupplier: this.addData.serviceSupplier,
          status: this.addData.status,
          companyCode: this.addData.company.code,
          companyName: this.addData.company.name,
          batchNo: this.addData.batchNo
        };
        this.listLoading = true;
        var url = '/rest/superviseContract/virtual-project/add';
        if (this.addData.id) {
          url = '/rest/superviseContract/virtual-project/edit'
        }
        this.$http({
          method: 'POST',
          url: url,
          data: submitData
        }).then(res => {
          this.listLoading = false;
          if (res.data.code == '0' && res.data.status == 200) {
            this.showAddDialog = false;
            this.clearAddData();
            this.getData();
            utils.myNotify(this, 'success', res, '操作成功')
          } else {
            utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
          }
        }).catch(err => {
          this.listLoading = false;
          utils.myNotify(this, "error", err, '操作失败');
        })
      },
      /**
       * 获取虚拟项目数据
       * @param id
       */
      getVirtualProjectInfo(id) {
        this.clearAddData();
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/get',
          params: {
            id: id
          }
        }).then(res => {
          if (res.data.code == '0' && res.data.status == 200 && res.data.data) {
            var info = res.data.data;
            this.addData = {
              id: info.id,
              projectCode: info.projectCode,
              projectName: info.projectName,
              serviceSupplier: info.serviceSupplier,
              status: info.status,
              company: {
                code: info.companyCode,
                name: info.companyName
              },
              batchNo: info.batchNo
            };
            this.showAddDialog = true;
          }
        }).catch(err => {
        });
      },
      /**
       * 只能输入汉字、英文、数字
       * @param e
       */
      inputLimit1(e) {
        e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, "");
      },
      /**
       * 只能输入字母、数字和英文横杠线
       * @param e
       */
      inputLimit2(e) {
        e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\-]/g, "");
      },
      /**
       * 只能输入字母、数字、中英文括号、英文横杠线、中英文空格
       * @param e
       */
      inputLimit3(e) {
        e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5- ()（）\-]/g, "");
      },
      /**
       * 只能输入字母、数字和英文横杠线
       * @param e
       */
      inputLimit4(e) {
        e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\-]/g, "");
      },
      /**
       * 显示供应商维护列表
       * @param projectCode
       */
      supplierListDialog(projectCode) {
        this.supplierConditionData.projectCode = projectCode;
        this.supplierProjectCode = projectCode;
        this.getSupplierList(projectCode);
      },
      /**
       * 查询供应商数据
       * @param projectCode
       */
      getSupplierList(projectCode) {
        this.supplierListLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/supplier/list',
          params: this.supplierConditionData
        }).then(res => {
          this.supplierTableData = res.data.data.items;
          this.supplierTotal = res.data.data.totalItemsCount;
          this.supplierListLoading = false;
          this.showSupplierDialog = true;
        }).catch(err => {
          this.supplierListLoading = false;
        });
      },
      /**
       *供应商列表分页信息变化
       * @param val
       */
      handleSupplierSizeChange(val) {
        this.supplierConditionData.pageSize = val;
        this.getSupplierList(this.supplierProjectCode);
      },
      /**
       * 供应商列表分页信息变化
       * @param val
       */
      handleSupplierCurrentChange(val) {
        this.supplierConditionData.pageNo = val;
        this.getSupplierList(this.supplierProjectCode);
      },
      /**
       * 清除页面缓存编辑供应商维护数据
       */
      clearEditSupplierData() {
        this.editSupplierData = {
          id: null,
          projectCode: null,
          supplierCode: null,
          supplierName: null,
          supplierBank: null,
          supplierBankAccount: null,
          beginDate: null,
          endDate: null,
          service: null,
          serviceOpenBank: null,
          serviceOpenBankCardNo: null
        };
      },
      /**
       * 打开编辑供应商弹出框
       * @param id
       */
      editSupplierDialog(id) {
        this.clearEditSupplierData();
        if (id) {
          // 编辑
          this.editSupplierFlag = true;
          this.editSupplierData.id = id;
          this.$http({
            method: 'GET',
            url: '/rest/superviseContract/virtual-project/supplier/get',
            params: {id: id}
          }).then(res => {
            if (res.data.code == '0' && res.data.status == 200 && res.data.data) {
              var info = res.data.data;
              this.editSupplierData = {
                id: info.id,
                projectCode: info.projectCode,
                supplier: {
                  name: info.supplierName,
                  code: info.supplierCode
                },
                service: {
                  name: info.serviceNm,
                  code: info.serviceId
                },
                supplierBank: info.supplierBank,
                supplierBankAccount: info.supplierBankAccount,
                beginDate: info.beginDate,
                endDate: info.endDate,
                serviceOpenBank: info.serviceOpenBank,
                serviceOpenBankCardNo: info.serviceOpenBankCardNo
              };
              this.doSearchOpenBanks(this.editSupplierData.supplier.code, 1);
              this.doSearchOpenBanks(this.editSupplierData.service.code, 2);

              this.doSearchOpenBankNos(this.editSupplierData.supplier.code,this.editSupplierData.supplierBank, 1);
              this.doSearchOpenBankNos(this.editSupplierData.service.code,this.editSupplierData.serviceOpenBank, 2);

              this.showSupplierEditDialog = true;
            }
          });
        } else {
          // 新增
          this.editSupplierFlag = false;
          this.showSupplierEditDialog = true;
        }
      },
      /**
       * 修改供应商数据
       */
      editSupplier() {
        if (!this.supplierProjectCode) {
          alert("虚拟性项目信息错误，请刷新页面");
          return;
        }
        if (!this.editSupplierFlag && !this.editSupplierData.supplier) {
          alert("未选择供应商");
          return;
        }
        if (!this.editSupplierFlag && !this.editSupplierData.supplierBank) {
          alert("未选择开户行");
          return;
        }
        if (!this.editSupplierFlag && !this.editSupplierData.supplierBankAccount) {
          alert("未选择银行账号");
          return;
        }
        if (!this.editSupplierData.beginDate) {
          alert("未选择开始日期");
          return;
        }
        if (!this.editSupplierData.endDate) {
          alert("未选择结束日期");
          return;
        }
        if (!utils.compareDate(this.editSupplierData.beginDate, this.editSupplierData.endDate)) {
          alert("开始日期不能大于结束日期");
          return;
        }
        if (!utils.compareDate(utils.currentDate(), this.editSupplierData.endDate)) {
          alert("结束日期不能晚于今天");
          return;
        }
        var submitData = {
          id: this.editSupplierData.id,
          projectCode: this.supplierProjectCode,
          supplierCode: this.editSupplierData.supplier.code,
          supplierName: this.editSupplierData.supplier.name,
          supplierBank: this.editSupplierData.supplierBank,
          supplierBankAccount: this.editSupplierData.supplierBankAccount,
          beginDate: this.editSupplierData.beginDate,
          endDate: this.editSupplierData.endDate,
          serviceId: this.editSupplierData.service == null ? null : this.editSupplierData.service.code,
          serviceNm: this.editSupplierData.service == null ? null : this.editSupplierData.service.name,
          serviceOpenBank: this.editSupplierData.serviceOpenBank,
          serviceOpenBankCardNo: this.editSupplierData.serviceOpenBankCardNo
        };
        var url = '/rest/superviseContract/virtual-project/supplier/add';
        if (this.editSupplierFlag) {
          url = '/rest/superviseContract/virtual-project/supplier/edit'
        }
        this.showSupplierEditDialog = true;
        this.$http({
          method: 'POST',
          url: url,
          data: submitData
        }).then(res => {
          if (res.data.code == '0' && res.data.status == 200) {
            this.showSupplierEditDialog = false;
            utils.myNotify(this, 'success', res, '操作成功')
            this.getSupplierList(this.supplierProjectCode);
          } else {
            utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
          }
        }).catch(err => {
          this.showSupplierEditDialog = false;
          utils.myNotify(this, "error", err, '操作失败');
        })
      },
      getServiceSuppliers() {
        this.$http({
          method: 'GET',
          url: '/rest/JiangYiJoint/getServiceSuppliers',
          
        }).then(res => {
          this.serviceSuppliers = res.data
        }).catch(err => {
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-btn {
    margin-left: 30px;
    margin-right: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/views/personnelCenter/virtualProject.vue